import { render, staticRenderFns } from "./RepairViewVehicle.vue?vue&type=template&id=01daa6dc"
import script from "./RepairViewVehicle.vue?vue&type=script&lang=js"
export * from "./RepairViewVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports